import { FC } from "react";

type IProps = {
  stroke?: string;
};

const SaveIcon: FC<IProps> = ({ stroke = "#6A6A6A" }) => {
  return (
    <svg
      width="13"
      height="13"
      viewBox="0 0 13 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.3398 2.80469C12.5859 3.05078 12.75 3.37891 12.75 3.73438V11.0625C12.75 11.8008 12.1484 12.375 11.4375 12.375H1.8125C1.07422 12.375 0.5 11.8008 0.5 11.0625V1.4375C0.5 0.726562 1.07422 0.125 1.8125 0.125H9.14062C9.49609 0.125 9.82422 0.289062 10.0703 0.535156L12.3398 2.80469ZM6.625 10.625C7.58203 10.625 8.375 9.85938 8.375 8.875C8.375 7.91797 7.58203 7.125 6.625 7.125C5.64062 7.125 4.875 7.91797 4.875 8.875C4.875 9.85938 5.64062 10.625 6.625 10.625ZM9.25 2.3125C9.25 2.23047 9.19531 2.14844 9.14062 2.06641L9.05859 1.98438C8.97656 1.92969 8.89453 1.875 8.8125 1.875H2.57812C2.38672 1.875 2.25 2.03906 2.25 2.20312V5.04688C2.25 5.23828 2.38672 5.375 2.57812 5.375H8.92188C9.08594 5.375 9.25 5.23828 9.25 5.04688V2.3125Z"
        fill="#254A7F"
      />
    </svg>
  );
};

export default SaveIcon;
